import { Arrow } from "@/components/landing/link";

/* The template's hero device, carrying this product's own Today screen.
   Styled by the phone rules in site.css, which the legacy layer still owns. */
export function Phone() {
  return (
    <div className="phone" aria-label="An example of the Vessa Today screen" role="img">
      <div className="island" />
      <div className="phone-content">
        <div className="phone-top">
          <span>9:41</span>
          <span>●●● Ʞɪ꟎ ▰</span>
        </div>
        <p className="phone-date">Tuesday, July 21</p>
        <h3>Today</h3>
        <section className="dose-card">
          <div className="pill-label">
            <span className="dot" /> NEXT EVENT
          </div>
          <strong>Weekly check-in</strong>
          <p>Your next planned dose is tomorrow.</p>
          <button>
            Log a dose <Arrow />
          </button>
        </section>
        <section className="check-card">
          <div>
            <span className="eyebrow">A gentle check-in</span>
            <strong>How are you feeling?</strong>
          </div>
          <div className="faces">
            <span>Low</span>
            <b>●</b>
            <b>●</b>
            <b>●</b>
            <b>●</b>
            <span>High</span>
          </div>
        </section>
        <section className="mini-row">
          <div>
            <span>Hydration</span>
            <strong>
              3 <small>cups</small>
            </strong>
          </div>
          <div>
            <span>This week</span>
            <strong>
              4 <small>check-ins</small>
            </strong>
          </div>
        </section>
        <div className="phone-tabs">
          <b>Today</b>
          <span>Week</span>
          <span>Journey</span>
          <span>Profile</span>
        </div>
      </div>
    </div>
  );
}
